export interface CostSummary {
  isProtectionSelected: boolean;
  replacementCost: number;
  monthlyPayment: number;
}

export const CostSummary = undefined;
